// JavaScript Document
jQuery(function($){
    
    //-----------------------------
    // sp menu
    //-----------------------------
    $('#menu-btn').click(function(){
        $(this).toggleClass('active');
        $('#global-header').toggleClass('active');
    })

    
    
    //-----------------------------
    // backtotop
    //-----------------------------
    $(window).scroll(function(){
        var now_pos = $(window).scrollTop();
        if ( now_pos > 500 ) {
            $('#backtotop').addClass('show');
        } else {
            $('#backtotop').removeClass('show');
        }
    });
     
    $('#backtotop').click(function(){
        $('html,body').stop().animate({ scrollTop: 0 });
        return false;
    });
    
    //-----------------------------
    // scroll
    //-----------------------------
    //contents scroll
    $('.scroll a').click(function(){
        var href= $(this).attr("href");
        var href_slice = href.split('#');
        var header_height = $('#global-header').height();

        if ( $('#'+href_slice[1]).length > 0 ) {
            $('#menu-btn').removeClass('active');
            $('#global-header').removeClass('active');

            var position =  $('#'+href_slice[1]).offset().top - header_height;
            $("html, body").stop().animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });

    window.addEventListener('load', function(){
        var hash = location.hash;
        var header_height = $('#global-header').height();

        if ( hash != "" && hash != "undefined" ) {
            var hash_position =  $(hash).offset().top - header_height;
            $("html, body").stop().animate({scrollTop:hash_position}, 550, "swing");
            return false;
        }
    });

    //-----------------------------
    // iframe responsive
    //-----------------------------
    if ( $('iframe').length > 0 ) {
        $('iframe').each(function(){
            var iframe_src = $(this).attr('src');
            //youtube
            if ( iframe_src.indexOf('youtube.com') != -1 ) {
                $(this).wrap('<div class="youtube-wrap"></div>');
            }
        });
    }

   //--------------------------------------
   //link off
   //--------------------------------------
   $('.link-off a').click(function(){
        return false;
   });
  
});
